export function init() {
  eventPageView();
  eventFormAbandonment();
}

function eventPageView() {
  const endpoint =
    (typeof guidedogsGlobals === 'object' &&
      `${guidedogsGlobals.gdresturl}fc/v`) ||
    '';
  fetch(endpoint).catch(
    e => {throw new Error(`Failed to register page view. Error: ${e}. Endpoint: ${endpoint}.`)}
  );
}

function eventFormAbandonment() {
  document.addEventListener('GDformAbandonment', (e) => {
    const endpoint =
      (typeof guidedogsGlobals === 'object' &&
        `${guidedogsGlobals.gdresturl}fc/fa`) ||
      '';
    fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify(e.detail),
      headers: {
        'Content-Type': 'application/json',
      },
    });
  });
}

export function eventFormAssembly(postData) {
  const endpoint =
    (typeof guidedogsGlobals === 'object' &&
      `${guidedogsGlobals.gdresturl}fc/fassembly`) ||
    '';
  fetch(endpoint, {
    method: 'POST',
    body: JSON.stringify(postData),
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
